<template>
  <div v-if="src" class="img-group">
    <div class="talk-group fbox2">
      <slot></slot>
    </div>
    <div class="img-box fbox1">
      <img :src="image_src" class="img-fluid" alt="" />
    </div>
  </div>
  <div v-else class="talk-group">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "TalkGroup",
  props: {
    src: { type: String, default: "" },
  },
  computed: {
    image_src() {
      return require("@/assets/images/sv/" + this.src);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";

.img-group {
  display: flex;
  @include mq-down(md) {
    flex-wrap: wrap;
  }
  > .talk-group {
    @include mq-up(md) {
      width: 50%;
    }
    &.fbox2 {
      @include mq-down(md) {
        order: 1;
      }
    }
  }
  > .img-box {
    @include mq-up(md) {
      width: 50%;
      padding-left: 40px;
    }
    @include mq-down(md) {
      margin-bottom: 40px;
    }
    &.fbox1 {
      @include mq-down(md) {
        order: 0;
      }
    }
  }
}
</style>
